import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { Lightbulb } from "lucide-react";

const LandingPage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleStart = () => {
    // Single entry point into the app (email / Google auth handled on /login)
    navigate("/login");
  };

  const handleLogin = () => {
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-paper flex flex-col">
      {/* Top bar with brand + language + secondary login */}
      <header className="w-full border-b border-stone-200 bg-white/80 backdrop-blur-sm">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <Lightbulb className="w-5 h-5 text-white" />
            </div>
            <span className="font-heading font-semibold text-lg text-stone-900">
              {t("brand_name")}
            </span>
          </div>
          <div className="flex items-center gap-3">
            <LanguageSwitcher />
            <Button
              variant="outline"
              size="sm"
              className="border-stone-300 text-stone-700"
              onClick={handleLogin}
            >
              {t("nav_login")}
            </Button>
          </div>
        </div>
      </header>

      {/* Centered hero */}
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="max-w-xl w-full mx-auto text-center space-y-8 py-16">
          <div className="space-y-3">
            <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-stone-900">
              {t("brand_name")}
            </h1>
            <p className="text-base sm:text-lg text-stone-600 leading-relaxed">
              {t("brand_tagline")}
            </p>
          </div>

          <div className="space-y-3">
            <Button
              onClick={handleStart}
              className="btn-primary w-full sm:w-auto px-10 py-3 text-lg font-semibold"
            >
              {t("landing_start_innovating")}
            </Button>
            <p className="text-xs sm:text-sm text-stone-500">
              {t("nav_login")} / {t("nav_get_started")} happens after you click <span className="font-medium">Start</span>.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LandingPage;
